import React from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

interface AccordionSectionProps {
  title: string;
  icon?: React.ReactNode;
  isOpen?: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({ title, icon, isOpen, onToggle, children }) => {
  return (
    <div className={`accordion-section ${isOpen ? 'open' : ''}`}>
      <button className="accordion-trigger" onClick={onToggle}>
        <div className="accordion-title-wrapper">
          {icon && <span className="accordion-icon">{icon}</span>}
          <span className="accordion-title">{title}</span>
        </div>
        {isOpen ? <UpOutlined className="accordion-chevron" /> : <DownOutlined className="accordion-chevron" />}
      </button>
      <div className="accordion-content">
        <div className="accordion-content-inner">
          {children}
        </div>
      </div>
    </div>
  );
};
